import React from "react";
import { Row, Col, Card } from "antd";
import i18n from "../../../i18n";
import { history } from "../../../reducers/configureStore";
import { Metrics } from "../../../theme";
import { isAlive, ArrayUtil, RouteUtil, OrgUtil } from "../../../util";
import { CompareCol, CompareDiv } from "../../../containers/ReportPanels/CompareValuePanel";
import { RouteKeys, AttrRouteFormat } from "../../../constants/route";
import { CounselingChart } from "./index";
import { GraphDataMaker } from "../../../util/helper/graph";
import GenericGraphDrawer, { combineKeyWithCategory } from "../GenericGraphDrawer";
import { CounselingSupportGraph } from "../../../constants/supportGraph";

export const DrawCounselingGraph = ({
	typeKey, object, previousObject, 
	isVertical, colorType, short, clickHeader = true,
	height, showLegend, showValue, onClick, header, pushOnTypeClick
})=>{
	let data = [];
	let def_header = "";
	const shareProps = {
		data:object,
		previousData:previousObject,
		isVertical,
		colorType,
		short,
		showLegend,
		height,
		showValue,
		onClick,
	};
	switch(typeKey){
	case CounselingSupportGraph.Tag:
		// def_header = header || i18n.t("session_by.topic");
		def_header = header || i18n.t("visit_by.topic");
		return <CounselingChart.ProgressChart 
			{...shareProps}
			header={def_header} 
			onHeaderClick={clickHeader ? ()=>history.push(RouteKeys.COUNSELING_BY_TOPIC) : undefined}
			onLegendClick={pushOnTypeClick ? (value)=>{history.push(RouteKeys.COUNSELING_BY_TOPIC, value);} : undefined}
			showSize={4}
		/>;
	case CounselingSupportGraph.Gender:
		// def_header = header || i18n.t("session_by.gender");
		def_header = header || i18n.t("visit_by.gender");
		return <CounselingChart.PieObjectChart
			{...shareProps}
			header={def_header}
			onHeaderClick={clickHeader ? ()=>history.push(RouteKeys.COUNSELING_BY_GENDER) : undefined}
			onLegendClick={pushOnTypeClick ? (value)=>{history.push(RouteKeys.COUNSELING_BY_GENDER, value);} : undefined}
		/>;
	case CounselingSupportGraph.ProviderType:
		def_header = header || i18n.t("visit_by.provider");
		return <CounselingChart.PieObjectChart
			{...shareProps}
			header={def_header}
			onHeaderClick={clickHeader ? ()=>history.push(RouteKeys.COUNSELING_BY_PROVIDER) : undefined}
			onLegendClick={pushOnTypeClick ? (value)=>{history.push(RouteKeys.COUNSELING_BY_PROVIDER, value);} : undefined}
		/>;
	case CounselingSupportGraph.Platform:
		def_header = header || i18n.t("visit_by.platform");
		return <CounselingChart.PlatformChart
			{...shareProps}
			header={def_header}
			onHeaderClick={clickHeader ? ()=>history.push(RouteKeys.COUNSELING_BY_PLATFORM) : undefined}
			onLegendClick={pushOnTypeClick ? (value)=>{history.push(RouteKeys.COUNSELING_BY_PLATFORM, value);} : undefined}
		/>;
	case CounselingSupportGraph.AgeRange:
		def_header = header || i18n.t("visit_by.age_range");
		return <CounselingChart.ColumnObjectChart
			{...shareProps}
			header={def_header}
			onHeaderClick={clickHeader ? ()=>history.push(RouteKeys.COUNSELING_BY_AGE) : undefined}
			onLegendClick={pushOnTypeClick ? (value)=>{history.push(RouteKeys.COUNSELING_BY_AGE, value);} : undefined}
			showColor = {false}
			removeZero = {false} 
			orderColor = {false}
		/>;
	case CounselingSupportGraph.Returning:
		def_header = header || i18n.t("visit_by.returning");
		return <CounselingChart.ReturningChart 
			{...shareProps}
			header={def_header} 
			onHeaderClick={clickHeader ? ()=>history.push(RouteKeys.COUNSELING_BY_USER_RETENTION) : undefined}
			onClick={pushOnTypeClick ? (value)=>{history.push(RouteKeys.COUNSELING_BY_USER_RETENTION, value);} : onClick}
			isLoadMore={false}
		/>;
	case CounselingSupportGraph.Feedback:
		def_header = header || i18n.t("visit_by.feedback");
		return <CounselingChart.VisitFeedback 
			{...shareProps}
			header={def_header}
			onHeaderClick={clickHeader ? ()=>history.push(RouteKeys.COUNSELING_BY_FEEDBACK) : undefined}
			onClick={pushOnTypeClick ? (value)=>{history.push(RouteKeys.COUNSELING_BY_FEEDBACK, value);} : onClick}
		/>;
	case CounselingSupportGraph.VisitOutcome:
		def_header = header || i18n.t("visit_by.visit_outcome");
		return <CounselingChart.ColumnObjectChart 
			{...shareProps}
			header={def_header}
			onHeaderClick={clickHeader ? ()=>history.push(RouteKeys.COUNSELING_BY_VISIT_OUTCOME) : undefined}
			onLegendClick={pushOnTypeClick ? (value)=>{history.push(RouteKeys.COUNSELING_BY_VISIT_OUTCOME, value);} : undefined}
			graphTextKey = "label"
			listTextKey = "label"
			translate={true}
			orderColor = {false}
		/>;
	default:
		const catNames = Array.from(OrgUtil.getAllCategoryName(), k=>k.toLowerCase());
		if(catNames.indexOf(typeKey.toLowerCase())!==-1){
			const rounteKey = RouteUtil.CreateCategoryRouteKeyByName(typeKey, AttrRouteFormat.COUNSELING);
			return <CounselingChart.CatgoryChart
				{...shareProps}
				category_name={typeKey}
				onHeaderClick={clickHeader ? ()=>(
					history.push(rounteKey)
				) : undefined}
				onLegendClick={pushOnTypeClick ? (value)=>{history.push(rounteKey, value);} : undefined}
			/>;
		}else{
			console.error(`no register type of ${typeKey}`);
			return <div />;
		}
	}
};
const createMutateSummary = (summary)=>{
	if(!isAlive(summary)){
		return {};
	}
	const mutateSummary = {...summary};
	if(isAlive(mutateSummary[CounselingSupportGraph.PatientFeedback], 
		mutateSummary[CounselingSupportGraph.ProviderFeedback])){
		mutateSummary[CounselingSupportGraph.Feedback] = {
			[CounselingSupportGraph.PatientFeedback]:{...mutateSummary[CounselingSupportGraph.PatientFeedback]},
			[CounselingSupportGraph.ProviderFeedback]:{...mutateSummary[CounselingSupportGraph.ProviderFeedback]}
		};
	}
	delete mutateSummary[CounselingSupportGraph.PatientFeedback];
	delete mutateSummary[CounselingSupportGraph.ProviderFeedback];
	return mutateSummary;
};
const CounselingChartListDrawer = (props)=>{
	const { summary, previousSummary } = props;
	const mutateSummary = createMutateSummary(summary);
	const mutatePreviousSummary = createMutateSummary(previousSummary);
	return <GenericGraphDrawer 
		{...props}
		supportGraphKeys={Object.values(CounselingSupportGraph).concat(OrgUtil.getAllCategoryName())}
		mutateSummary={mutateSummary}
		mutatePreviousSummary={mutatePreviousSummary}
		drawEach={DrawCounselingGraph}
	/>;
};
export default CounselingChartListDrawer;


// WEBPACK FOOTER //
// ./src/components/report/counseling/CounChartList.js